<template>
    <div>
        <v-toolbar
            color="primary"
            dark
            :class="{'toolbar-hide-navigation': hideNavigation}"
        >
            <v-toolbar-side-icon
                v-if="!hideNavigation"
                @click="showNav = true"
            />
            <v-toolbar-title>
                Product Return Portal
            </v-toolbar-title>
        </v-toolbar>
        <v-navigation-drawer
            v-model="showNav"
            fixed
            temporary
        >
            <v-list>
                <router-link
                    v-for="item in navItems"
                    :key="item.text"
                    :to="item.route"
                >
                    <v-list-tile
                        exact
                    >
                        <v-list-tile-action>
                            <v-icon>
                                {{ item.icon }}
                            </v-icon>
                        </v-list-tile-action>
                        <v-list-tile-title>
                            {{ item.text }}
                        </v-list-tile-title>
                    </v-list-tile>
                </router-link>
            </v-list>
        </v-navigation-drawer>
    </div>
</template>

<script>
import UserBus from '../utils/buses/userBus'

export default {
    props: {
        hideNavigation: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        navItems: function () {
            const navItems = [
                {
                    text: 'Product Returns',
                    icon: 'fas fa-shipping-fast',
                    route: {
                        name: 'returnsList'
                    }
                }
            ]

            if (UserBus.userIs.salesRep()) {
                navItems.push({
                    text: 'Invoice search',
                    icon: 'fa-search',
                    route: {
                        name: 'invoiceSearch'
                    }
                })
            }

            return navItems
        }
    },
    data () {
        return {
            showNav: false
        }
    }
}
</script>

<style scoped lang="scss">
.v-list a {
    color: inherit;
    text-decoration: none;
}

.v-toolbar {
    background-image: url("/images/garland-logo.svg");
    background-size: 125px;
    background-position-y: center;
    background-position-x: 75px;

    &.toolbar-hide-navigation {
        background-position-x: 33px; // 75px - 42px
    }

    &__title {
        margin-left: 165px;
    }

    @media screen and (max-width: 599px) {
        background-position-x: -12px !important;

        &.toolbar-hide-navigation {
            background-position-x: 33px; // 75px - 42px

            .v-toolbar__title {
                margin-left: 112px; // 80px + 42px
            }
        }

        &__title {
            margin-left: 80px;
        }
    }
}
</style>
